<div style="text-align:center;padding-top:10px" *ngIf="immunizations.length == 0  && isBusy==false" translate>No Immunizations data exists for student</div>
<div *ngIf="immunizations.length > 0 ">
  <mat-table #table matSort matSortDisableClear matSortActive="Name" [dataSource]="angularMatData" aria-label="Immunizations Data Table" style="height:100%;min-width: 1100px;">
    <ng-container matColumnDef="Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:320px;"><span translate>Name</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="Name" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="min-width:320px;">{{element.Name}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DosesReceived">
      <mat-header-cell *matHeaderCellDef style="min-width:450px;"><span translate>Doses Received</span></mat-header-cell>
      <mat-cell *matCellDef="let element" style="min-width:450px;">
        <ng-template *ngTemplateOutlet="templateRef; context: { $implicit: element }"></ng-template>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ExemptionCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:320px;"><span translate>Exemption Code</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="ExemptionCode" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="min-width:320px;">{{element.ExemptCode}}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedImmunizationColumns;"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedImmunizationColumns;" [attr.aria-label]="getImmunizationsAriaRow(row)"></mat-row>
  </mat-table>
</div>
<div>
  <ng-template #templateRef let-element>
    <table>
      <tr>
        <td style="width:75px"><span *ngIf="element.Date1 != '0001-01-01T00:00:00'">{{element.Date1|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px"><span *ngIf="element.Date2 != '0001-01-01T00:00:00'">{{element.Date2|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px"><span *ngIf="element.Date3 != '0001-01-01T00:00:00'">{{element.Date3|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px"><span *ngIf="element.Date4 != '0001-01-01T00:00:00'">{{element.Date4|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px"><span *ngIf="element.Date5 != '0001-01-01T00:00:00'">{{element.Date5|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px"><span *ngIf="element.Date6 != '0001-01-01T00:00:00'">{{element.Date6|date:'MM/dd/yy'}}</span></td>
      </tr>
      <tr *ngIf="element.Date7 != '0001-01-01T00:00:00'">
        <td style="width:75px;"><span *ngIf="element.Date7  != '0001-01-01T00:00:00'">{{element.Date7|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date8  != '0001-01-01T00:00:00'">{{element.Date8|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date9  != '0001-01-01T00:00:00'">{{element.Date9|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date10 != '0001-01-01T00:00:00'">{{element.Date10|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date11 != '0001-01-01T00:00:00'">{{element.Date11|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date12 != '0001-01-01T00:00:00'">{{element.Date12|date:'MM/dd/yy'}}</span></td>
      </tr>
      <tr *ngIf="element.Date13 != '0001-01-01T00:00:00'">
        <td style="width:75px;"><span *ngIf="element.Date13 != '0001-01-01T00:00:00'">{{element.Date13|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date14 != '0001-01-01T00:00:00'">{{element.Date14|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date15 != '0001-01-01T00:00:00'">{{element.Date15|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date16 != '0001-01-01T00:00:00'">{{element.Date16|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date17 != '0001-01-01T00:00:00'">{{element.Date17|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date18 != '0001-01-01T00:00:00'">{{element.Date18|date:'MM/dd/yy'}}</span></td>
      </tr>
      <tr *ngIf="element.Date19 != '0001-01-01T00:00:00'">
        <td style="width:75px;"><span *ngIf="element.Date19 != '0001-01-01T00:00:00'">{{element.Date19|date:'MM/dd/yy'}}</span></td>
        <td style="width:75px;"><span *ngIf="element.Date20 != '0001-01-01T00:00:00'">{{element.Date20|date:'MM/dd/yy'}}</span></td>
      </tr>
    </table>
  </ng-template>
</div>
